<template>
  <div>
    <v-data-table
      height="calc(100vh - 238px)"
      :headers="headers"
      :items="items"
      class="table-full-screen pl-2"
      :items-per-page="-1"
      fixed-header
      item-key="filial"
    >
      <template #top>
        <div class="d-flex py-2 pr-3 pl-1">
          <p class="ma-0 font-weight-medium font-16">
            <v-icon style="font-size: 22px">mdi-format-list-bulleted</v-icon>
            Filiais parametrizadas
          </p>

          <v-spacer />

          <v-btn color="primary" small @click="dialog_cadastro = !dialog_cadastro">
            <v-icon left>mdi-plus</v-icon>
            Novo
          </v-btn>
        </div>
      </template>

      <template #item.acoes="{item}">
        <v-icon @click="editarFilial(item)">mdi-pencil</v-icon>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialog_cadastro"
      titulo="Nova parametrização"
      content-class="bra-20"
      width="800"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title class="py-4">
          <p class="ma-0">{{ item_cadastro.editando ? 'Editando' : 'Nova'}} parametrização</p>

          <v-spacer />

          <v-btn icon @click="fecharDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-3">
          <SysFilialGrupoAutocomplete
            v-model="item_cadastro.filial"
            :id-grupo="GRUPO_COMPRA"
            label="Selecione a filial*"
            outlined
            :disabled="item_cadastro.editando"
            :filiais_para_ocultar="FILIAIS_JA_PARAMETRIZADAS"
            :error-messages="mensagensErrorCampoValidacao('filial')"
          />

          <div class="d-flex">
            <div class="w-50-per mr-2">
              <v-text-field
                v-model="item_cadastro.codtipoper"
                label="Tipo operação (codtipoper)*"
                outlined
                clearable
                :error-messages="mensagensErrorCampoValidacao('codtipoper')"
                @focus="$event.target.select()"
              />
            </div>

            <div class="w-50-per ml-2">
              <v-text-field
                v-model="item_cadastro.codnat"
                label="Código da natureza (codnat)*"
                outlined
                clearable
                :error-messages="mensagensErrorCampoValidacao('codnat')"
                @focus="$event.target.select()"
              />
            </div>
          </div>

          <div class="d-flex">
            <div class="w-50-per mr-2">
              <v-text-field
                v-model="item_cadastro.tipmov"
                label="Tipo do movimento (tipmov)*"
                outlined
                clearable
                :error-messages="mensagensErrorCampoValidacao('tipmov')"
                @focus="$event.target.select()"
              />
            </div>

            <div class="w-50-per ml-2">
              <v-text-field
                v-model="item_cadastro.codcencus"
                label="Código do centro de custo (codcencus)*"
                outlined
                clearable
                :error-messages="mensagensErrorCampoValidacao('codcencus')"
                @focus="$event.target.select()"
              />
            </div>
          </div>

          <div class="d-flex">
            <div class="w-50-per mr-2">
              <v-text-field
                v-model="item_cadastro.codtipvenda"
                label="Código tipo venda (codtipvenda)"
                outlined
                clearable
                @focus="$event.target.select()"
              />
            </div>

            <div class="w-50-per ml-2">
              <v-text-field
                v-model="item_cadastro.codlocalorig"
                label="Código do local de estoque (codlocalorig)*"
                outlined
                clearable
                :error-messages="mensagensErrorCampoValidacao('codlocalorig')"
                @focus="$event.target.select()"
              />
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="mt-n1">
          <v-spacer />

          <v-btn text color="primary" @click="salvar">
            salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FilialAPI from "../../api/filial.js";
import {logout} from "../../helpers";
import SysFilialGrupoAutocomplete from "../utils/crud/SysFilialGrupoAutocomplete";
import {required} from "vuelidate/lib/validators";

const item_cadastro_padrao = {
  filial: '',
  codtipoper: '',
  codnat: '',
  tipmov: '',
  codcencus: '',
  codtipvenda: '',
  codlocalorig: '',
};

export default {
  name: "ParametrizacaoFiliaisCompra",
  components: {
    SysFilialGrupoAutocomplete
  },
  data: () => ({
    headers: [
      { text: 'Sistema de integração',  value: 'descricao_erp' },
      { text: 'Filial',  value: 'filial' },
      { text: 'Tipo operação (codtipoper)',  value: 'codtipoper' },
      { text: 'Tipo do movimento (tipmov)',  value: 'tipmov' },
      { text: 'Código da natureza (codnat)',  value: 'codnat' },
      { text: 'Código do centro de custo (codcencus)',  value: 'codcencus' },
      { text: 'Código tipo venda (codtipvenda)',  value: 'codtipvenda' },
      { text: 'Código do local de estoque (codlocalorig)',  value: 'codlocalorig' },
      { text: 'Ações',  value: 'acoes', width: 50 },
    ],
    items: [],
    item_cadastro: Object.assign({}, item_cadastro_padrao),
    dialog_cadastro: false
  }),
  validations: {
    item_cadastro: {
      filial: {required},
      codtipoper: {required},
      tipmov: {required},
      codnat: {required},
      codcencus: {required},
      codlocalorig: {required},
    }
  },
  computed: {
    GRUPO_COMPRA() {
      return parseInt(this.$store.getters['usuario/getGrupoCompras']);
    },
    FILIAIS_JA_PARAMETRIZADAS() {
      const filiais = this.Helpers.arrayColumn(this.items, 'filial');
      return filiais.filter(filial => filial !== this.item_cadastro.filial);
    }
  },
  mounted() {
    this.buscarParametrizacaoFiliais();
  },
  methods: {
    buscarParametrizacaoFiliais() {
      this.$store.dispatch("loading/addRequisicao",
        FilialAPI.buscarParametrizacaoFiliaisApiSankhya()
          .then(this.atualizarDadosGrid)
          .catch(logout)
      );
    },
    atualizarDadosGrid(parametrizacoes) {
      this.items = parametrizacoes;
    },
    editarFilial(item) {
      this.item_cadastro = Object.assign({}, item);
      this.item_cadastro.editando = true;
      this.dialog_cadastro = true;
    },
    salvar() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      this.$store.dispatch("loading/addRequisicao",
        FilialAPI.salvarParametrizacaoFiliaisApiSankhya(this.item_cadastro)
          .then(this.sucessoAoSalvar)
          .catch(logout)
      );
    },
    sucessoAoSalvar() {
      this.buscarParametrizacaoFiliais();
      this.fecharDialog();
    },
    fecharDialog() {
      this.item_cadastro = Object.assign({}, item_cadastro_padrao);
      this.$v.$reset();
      this.dialog_cadastro = false;
    },
    mensagensErrorCampoValidacao(campo) {
      const errors = [];
      if (!this.$v.item_cadastro[campo].$dirty) return errors;
      !this.$v.item_cadastro[campo].required && errors.push("Campo Obrigatório.");
      return errors;
    }
  }
}
</script>

<style scoped>
.w-50-per {
  width: 50%;
}
</style>
